import styled from 'styled-components';
import useBackendPath from '../../hooks/useBackendPath';

import { colours, device } from '../../styles/constants';
import { lg, xl } from '../../styles/mixins';

export const Container = styled.div(() => {
  const { backendPath } = useBackendPath();

  return {
    alignItems: 'flex-start',
    background: `linear-gradient(
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0.4)
    ), url(${backendPath}/assets/images/artboards/artboard_1_mob.jpg)`,
    backgroundSize: 'cover',
    bottom: 0,
    color: 'white',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    left: 0,
    paddingBottom: 150,
    paddingTop: 150,
    right: 0,
    top: 0,
    zIndex: 0,
    [`@media ${device.tabletP}`]: {
      backgroundPosition: 'right top',
    },
    [`@media ${device.tabletL}`]: {
      backgroundImage: `linear-gradient(
        rgba(0, 0, 0, 0.4),
        rgba(0, 0, 0, 0.4)
      ), url(${backendPath}/assets/images/artboards/background-1.jpg)`,
      paddingBottom: lg(130),
      paddingTop: lg(130),
    },
    [`@media ${device.desktop}`]: {
      paddingBottom: xl(230),
      paddingTop: xl(230),
    },
  };
});

export const ContainerInner = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: 25,
  width: 'auto',
  [`@media ${device.tabletL}`]: {
    width: '65%',
  },
});

export const Divider = styled.div({
  backgroundColor: colours.yellow,
  height: 2,
  marginBottom: 25,
  marginTop: 25,
  width: 110,
  [`@media ${device.tabletL}`]: {
    height: lg(2),
    marginBottom: lg(37),
    marginTop: lg(35),
    width: lg(112),
  },
  [`@media ${device.desktop}`]: {
    height: xl(2),
    marginBottom: xl(37),
    marginTop: xl(35),
    width: xl(112),
  },
});

export const Heading = styled.h1({
  fontSize: 23,
  fontWeight: 800,
  fontStretch: 'condensed',
  textTransform: 'uppercase',
  lineHeight: 1.1,
  [`@media ${device.tabletL}`]: {
    fontSize: lg(35),
    margin: 0,
  },
  [`@media ${device.desktop}`]: {
    fontSize: xl(35),
  },
});

export const Paragraph = styled.p({
  fontSize: 15,
  fontWeight: 400,
  marginLeft: 25,
  marginRight: 25,
  marginTop: 0,
  marginBottom: 0,
  [`@media ${device.tabletL}`]: {
    marginLeft: 0,
    marginRight: 0,
    fontSize: lg(28),
    maxWidth: lg(510),
  },
  [`@media ${device.desktop}`]: {
    fontSize: xl(28),
    maxWidth: xl(510),
  },
});

export const HeadingContainer = styled.div({
  padding: '0 25px',
  position: 'relative',
  width: '90%',
  [`@media ${device.tabletL}`]: {
    padding: 0,
    width: lg(580),
  },
  [`@media ${device.desktop}`]: {
    width: xl(580),
  },
});

export const Logo = styled.img({
  left: 280,
  position: 'absolute',
  right: 'auto',
  top: -15,
  width: 30,
  '@media (min-width: 495px)': {
    left: 400,
    width: 30,
  },
  [`@media ${device.tabletL}`]: {
    width: 37,
    left: 'auto',
    right: lg(-30),
    top: lg(-20),
  },
  [`@media ${device.desktop}`]: {
    width: 42,
    right: xl(-30),
    top: xl(-20),
  },
});
